import { filters } from '../constants'
import { todoFilterStatuses } from '@app/insights/types'

export const todosDefinition = {
  type: filters.TODOS,
  nameKey: 'todos',
  deployDate: '2026-07-20',
  ledgerRequired: true,
  // "To-do" is hyphenated in the title, so a search for "to do" (with a space)
  // won't match it; this alias keeps the filter findable by that spelling.
  searchKeywords: 'to do',

  statusOptions() {
    return Object.values(todoFilterStatuses).map((value) => ({
      value,
      label: I18n.t(`companies_overview.filters.todos.${value}`),
    }))
  },

  activeSubtitle(settings, getters) {
    const option = this.statusOptions().find((o) => o.value === settings.status)
    return [option?.label, this.getColumnSubtitle(settings, getters)]
      .filter(Boolean)
      .join(', ')
  },

  getColumnSubtitle(settings, getters) {
    const tagNames = (settings.tagIds ?? [])
      .map((id) => getters.getRemarkTagById(id)?.name)
      .filter(Boolean)

    if (tagNames.length === 0) {
      return ''
    }

    return I18n.t('companies_overview.filters.todos.tags_subtitle', {
      tags: new Intl.ListFormat(I18n.locale, { type: 'disjunction' }).format(
        tagNames
      ),
    })
  },

  // Excel export: label + counters only, no icons. Files without to-dos return
  // blank here; the export layer renders blank filter cells as a "-".
  formatForExport(value) {
    if (!value || typeof value === 'string') {
      return value || ''
    }

    if (!value.status || value.total === 0) {
      return ''
    }

    const label = I18n.t(`companies_overview.filters.todos.${value.status}`)
    return `${label} ${value.completed}/${value.total}`
  },

  serializeSettings(settings) {
    return {
      status: settings.status,
      tag_ids: settings.tagIds,
    }
  },

  deserializeSettings(params) {
    return {
      status: params.status,
      tagIds: params.tag_ids ?? [],
    }
  },
}
